import { render, staticRenderFns } from "./SkuPriceChange.vue?vue&type=template&id=da39a7ec&scoped=true&"
import script from "./SkuPriceChange.vue?vue&type=script&lang=js&"
export * from "./SkuPriceChange.vue?vue&type=script&lang=js&"
import style0 from "./SkuPriceChange.vue?vue&type=style&index=0&id=da39a7ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da39a7ec",
  null
  
)

export default component.exports